import routesallComponent from './routes.all.component';

let routesallModule = angular.module('routesall', [
])

.component('routesall', routesallComponent)

.name;

export default routesallModule;


// WEBPACK FOOTER //
// ./client/app/components/routes/all/index.js